<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Loading',
}
</script>

<script setup>
import {Loading as VanLoading} from 'vant'

</script>

<template>
  <div class="loading-wrapper">
    <div class="logo-wrapper">
      <van-loading
        :vertical="true"
        class="loading-indicator">
        加载中...
      </van-loading>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loading-wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
}

.loading-indicator {
  margin: auto;
}
</style>

